<template>
  <v-container fluid py-0 style="background-color: #E4E7EA;">
    <v-container class="myedu-content">
      <v-row v-for="(section, i) in pageData" :key="i">
        <v-col cols="12">
          <div class="font-weight-medium secondary--text section-title">
            {{ $t(section.title) }}
          </div>
        </v-col>
        <v-col cols="12" id="myedu-panels">
          <v-expansion-panels accordion>
            <v-expansion-panel
              class="mb-3 panel"
              v-for="(item, j) in section.data"
              :key="j"
            >
              <v-expansion-panel-header
                class="text-none py-3 py-sm-0 px-2 px-sm-6"
                disable-icon-rotate
                style="min-height:60px;"
              >
                <v-icon slot="actions" color="secondary" class="mr-0 mr-sm-3"
                  >mdi-unfold-more-horizontal</v-icon
                >
                <v-avatar
                  max-width="32"
                  min-width="32"
                  max-height="32"
                  min-height="32"
                  class="accent mr-4 mr-sm-6"
                >
                  <v-icon color="white" size="16">{{ item.icon }}</v-icon>
                </v-avatar>
                <span class="secondary--text font-weight-medium">{{ $t(item.title) }}</span>
              </v-expansion-panel-header>
              <v-expansion-panel-content
                eager
                v-html="$t(item.text)"
                class="panel-content flex-column primary--text"
              >
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import i18n from "@/plugins/i18n";

export default {
  components: {},

  created() {
    // console.log(i18n.locale, 123456)
  },
  mounted() {
    window.scrollTo(0, 0);
  },

  data: () => ({}),
  computed: {
    pageData() {
      return {
        1: {
          title: "moj_eduid_h1_1",
          data: [
            {
              icon: "mdi-text-box-multiple",
              title: "moj_eduid_1_1_title",
              text: `moj_eduid_1_1_text`
            },
            {
              icon: "mdi-lock",
              title: "moj_eduid_1_2_title",
              text: `moj_eduid_1_2_text`
            },
            {
              icon: "mdi-bank",
              title: "moj_eduid_1_3_title",
              text: `moj_eduid_1_3_text`
            },
          ]
        },
        2: {
          title: "moj_eduid_h1_2",
          data: [
            {
              icon: "mdi-help-circle",
              title: "moj_eduid_2_1_title",
              text: `moj_eduid_2_1_text`
            }
          ]
        },
        3: {
          title: "moj_eduid_h1_3",
          data: [
            {
              icon: "mdi-shield-check",
              title:
                "moj_eduid_3_1_title",
              text: `moj_eduid_3_1_text`
            },
            {
              icon: "mdi-cellphone-lock",
              title:
                "moj_eduid_3_2_title",
              text: `moj_eduid_3_2_text`
            },
            {
              icon: "mdi-clipboard-alert",
              title: "moj_eduid_3_3_title",
              text: `moj_eduid_3_3_text`
            }
          ]
        }
      };
    }
  }
};
</script>

<style lang="scss">
.section-title {
  font-size: 32px;
}
#myedu-panels {
  .panel-content {
    div {
      padding: 32px;
      padding-left: 80px;
    }
    li {
      display: list-item;
      font-size: 14px;
    }
    ul {
      list-style-type: initial;
    }
  }
  .v-expansion-panel-header {
    font-size: 18px;
  }
}

.myedu-content {
  padding: 40px 12px;
}

@media only screen and (max-width: 600px) {
  .section-title {
    font-size: 24px;
  }
  #myedu-panels {
    .panel-content div {
      padding: 16px;
    }
    .v-expansion-panel-header {
      font-size: 16px;
    }
  }
  .myedu-content {
    padding: 24px 12px;
  }
}

.login-btn-text {
  margin-left: 50px;
}

.login-btn {
  position: relative;
  display: flex;
  width: 100%;
  height: 56px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
}

.login-btn-icon {
  position: absolute;
  left: 0;
  height: 100%;
  background-color: #004379;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

@media only screen and (max-width: 380px) {
  .login-btn-text {
    margin-left: 80px !important;
  }
}
</style>
